import { dbgOn, dbg } from '../../utils/debugFlag'
/**
 * yFitTrace — TEMPORARY Y-fit debug trace (TF-switch investigation).
 *
 *   localStorage.yfitTrace = '1'     every mounted chart
 *   localStorage.yfitTrace = 'main'  only that chart (chartId: 'main' | 'B')
 *
 * Re-read at most once a second, so the off path is one Date.now() compare.
 * Every Y write / hold clear logs ONE line, tagged with the chart it came
 * from — a dual-chart cell keeps BOTH charts mounted (the hidden one with
 * display:none still runs its memo, sizer and fitGen refit), so an untagged
 * trace interleaves two charts and reads as one chart flip-flopping:
 *   [yfit] +ms #id tf=… H=… reason | lo..hi (visible scan) | c= h= | extra
 * Consecutive duplicates per chart are dropped. window.__yfit keeps the last
 * 600 lines; copy(window.__yfit.join('\n')) puts them on the clipboard.
 *
 * Delete this file and its call sites once the TF fit is confirmed.
 */
let _flag = ''
let _chk = 0
let _t0 = 0
const _last = new Map()

export function yfitOn(id) {
  const now = Date.now()
  if (now - _chk > 1000) {
    _chk = now
    try { _flag = (typeof localStorage !== 'undefined' && localStorage.getItem('yfitTrace')) || '' } catch { _flag = '' }
  }
  if (!_flag || _flag === '0' || !dbgOn()) return false
  return _flag === '1' || id == null || String(id) === _flag
}

const f = (v) => (Number.isFinite(v) ? (Math.abs(v) >= 100 ? v.toFixed(2) : v.toPrecision(6)) : String(v))

export function yfit(reason, { id, tf, H, lo, hi, c, h, extra } = {}) {
  if (!yfitOn(id)) return
  const body = `#${id ?? '?'} tf=${tf} H=${H ?? '?'} ${reason} | ${f(lo)}..${f(hi)} | c=${f(c)} h=${f(h)}${extra ? ' | ' + extra : ''}`
  const k = String(id)
  if (_last.get(k) === body) return
  _last.set(k, body)
  const now = Date.now()
  if (!_t0 || now - _t0 > 60000) _t0 = now
  const line = `[yfit] +${now - _t0}ms ${body}`
  dbg(line)
  if (typeof window !== 'undefined') {
    const b = window.__yfit || (window.__yfit = [])
    b.push(line)
    if (b.length > 600) b.splice(0, b.length - 600)
  }
}
